<template>
    <span class="absolute bg-red-500 p-1 rounded-2xl text-xs text-white z-10" v-if="discount">{{ discount }}%</span>
  </template>
  
  <script>
  export default {
    name: "DiscountBadge",
    props: ['discount']
  }
  </script>
  
  <style scoped>
  
  </style>